import { Grid2 } from "@mui/material";
import React from "react";

//local imports
import TimeRange from "../../../../GlobalComponents/TimeRange/TimeRange";
import { getIconForActivity } from "../../../../Utils/activityConstants";
import NoData from "../../../../GlobalComponents/NoData/NoData";
//styles
import { ActivityStyles } from ".";

//icons
import { ReactComponent as CalendarIcon } from "../../AdminAssets/svg/calendar.svg";
import { ReactComponent as UserIcon } from "../../AdminAssets/svg/person.svg";

function UserActivity(props) {
  const { activities, setSelectedTimeRange } = props;
  return (
    <Grid2 container className={ActivityStyles.container}>
      <Grid2 className={ActivityStyles.labelContainer}>
        <Grid2 item className={ActivityStyles.label}>
          User Activity
        </Grid2>
        <TimeRange onRangeSelect={setSelectedTimeRange} />
      </Grid2>
      <Grid2>
        {activities.length !== 0 ? (
          <>
            {activities.map((activity, index) => (
              <Grid2 key={index} className={ActivityStyles.activityContainer}>
                <Grid2 item className={ActivityStyles.IconFlexBox}>
                  <Grid2 item className={ActivityStyles.imgContainer}>
                    {getIconForActivity(activity.actionType, activity.payload)}
                  </Grid2>
                  <Grid2 item className={ActivityStyles.textContainer}>
                    {activity.message}
                  </Grid2>
                </Grid2>
                <Grid2 container className={ActivityStyles.flexContainer}>
                  <Grid2 container className={ActivityStyles.timeContainer}>
                    <CalendarIcon />
                    <Grid2 item className={ActivityStyles.timeText}>
                      {activity.time}
                    </Grid2>
                  </Grid2>
                  <Grid2 item className={ActivityStyles.userName}>
                    <Grid2 item className={ActivityStyles.userIcon}>
                      <UserIcon />
                    </Grid2>
                    <Grid2 item className={ActivityStyles.name}>
                      {activity.name}
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>
            ))}
          </>
        ) : (
          <NoData
            message={"No Activities"}
            style={{ marginTop: "100px" }}
          />
        )}
      </Grid2>
    </Grid2>
  );
}

export default UserActivity;
